import { Alert, Box, Slide } from '@mui/material';
import { useEffect } from 'react';
import CheckIcon from '../../Icons/CheckIcon';
import ErrorIcon from '../../Icons/ErrorIcon';

interface AlertMessageProps {
  show: boolean;
  type: 'success' | 'error';
  message: string;
  onClose: () => void;
}

const AlertMessage = ({ show, type, message, onClose }: AlertMessageProps) => {
  useEffect(() => {
    if (!show) return;
    const timer = setTimeout(() => {
      onClose();
    }, 5000);
    return () => clearTimeout(timer);
  }, [show, message, type, onClose]);

  return (
    <Slide key={`${type}-${message}`} direction="right" in={show} mountOnEnter unmountOnExit>
      <Alert
        data-testid={`alert-message-${type}`}
        severity={type}
        icon={false}
        sx={{
          position: 'fixed',
          bottom: 24,
          left: 24,
          zIndex: 9999,
          background: '#323232',
          borderRadius: '4px',
          minWidth: '344px',
          color: 'white',
          '& .MuiAlert-message': {
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 4,
          },
          boxShadow:
            '18px 0px rgba(0, 0, 0, 0.12), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 3px 5px -1px rgba(0, 0, 0, 0.20)',
        }}
      >
        <Box>{message}</Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box onClick={onClose} sx={{ cursor: 'pointer', color: 'white' }}>
            Close
          </Box>
          {type === 'success' ? <CheckIcon /> : <ErrorIcon />}
        </Box>
      </Alert>
    </Slide>
  );
};

export default AlertMessage;
